const showSwiftLoginBar = () => {
  // check if this page has indication to have Swift login bar
  const showLoginBar = document.querySelector('.js-show-swift-login-bar') !== null;
  if (showLoginBar) {
    document.querySelector('.wmnds-sign-in').style.display = 'block';
  }
};

export default showSwiftLoginBar;
